// extracted by mini-css-extract-plugin
export default {"mobileNumber":"Mobile_mobileNumber__LFUwf"};